import * as ace from "brace";
ace.define("ace/theme/vikingo",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {

exports.isDark = true;
exports.cssClass = "ace-vikingo";
exports.cssText = ".ace-vikingo .ace_gutter {\
\
color: #8E8E8E\
}\
.ace-vikingo .ace_print-margin {\
width: 1px;\
background: #555651\
}\
.ace-vikingo {\
background-color: #202020;\
color: #F8F8F2\
}\
.ace-vikingo .ace_scrollbar {\
	scrollbar-color: rgba(190, 207, 213, 0.5) rgba(108, 108, 108, 0.67);\
	scrollbar-width: thin;\
    transition: 0.15s all ease-in;\
}\
.ace-vikingo .ace_scrollbar:hover {\
	scrollbar-width: initial;\
}\
.ace-vikingo .ace_scrollbar-v::-webkit-scrollbar {\
  width: 5px;\
  transition: 0.15s all ease-in;\
}\
.ace-vikingo .ace_scrollbar-v:hover::-webkit-scrollbar {\
    width: 10px;\
}\
.ace-vikingo .ace_scrollbar-h::-webkit-scrollbar {\
  height: 5px;\
  transition: 0.15s all ease-in;\
}\
.ace-vikingo .ace_scrollbar-h:hover::-webkit-scrollbar {\
  height: 10x;\
}\
.ace-vikingo .ace_scrollbar::-webkit-scrollbar-track {\
  background-color: rgba(108, 108, 108, 0.67);\
  border-radius: 10px;\
}\
.ace-vikingo .ace_scrollbar::-webkit-scrollbar-thumb {\
  border-radius: 10px;\
  background-color: rgba(190, 207, 213, 0.5);\
}\
.ace-vikingo.ace_autocomplete {\
	width: 280px;\
	z-index: 200000;\
	background: #333;\
	color: #d7d7d7;\
	border: 1px #3e3e3e solid;\
	position: fixed;\
	box-shadow: 2px 3px 5px rgba(0,0,0,.2);\
	line-height: 1.4;\
	padding: 5px;\
	border-radius: 4px;\
}\
.ace-vikingo.ace_autocomplete .ace_marker-layer .ace_active-line {\
	background-color: #475B6F;\
	z-index: 1;\
}\
.ace-vikingo.ace_autocomplete .ace_completion-highlight {\
	color: #6097bf;\
	text-shadow: 0 0 0.01em;\
}\
.ace-vikingo .ace_rightAlignedText {\
	color: #8e8e8e;\
}\
.ace-vikingo.ace_autocomplete .ace_line-hover {\
    border: 1px solid #5d82aa;\
    margin-top: -1px;\
    background: rgba(134, 134, 134, 0.4);\
}\
.ace-vikingo .ace_cursor {\
color: #F8F8F0\
}\
.ace-vikingo .ace_marker-layer .ace_selection {\
background: #3E4649\
}\
.ace-vikingo.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px #272822;\
}\
.ace-vikingo .ace_marker-layer .ace_step {\
background: rgb(102, 82, 0)\
}\
.ace-vikingo .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid #49483E\
}\
.ace-vikingo .ace_marker-layer .ace_active-line {\
background: #333\
}\
.ace-vikingo .ace_gutter-active-line {\
background-color: #272727\
}\
.ace-vikingo .ace_marker-layer .ace_selected-word {\
border: 1px solid #49483E\
}\
.ace-vikingo .ace_invisible {\
color: #52524d\
}\
.ace-vikingo .ace_entity.ace_name.ace_tag,\
.ace-vikingo .ace_keyword,\
.ace-vikingo .ace_meta.ace_tag,\
.ace-vikingo .ace_storage {\
color: #8FB9E1\
}\
.ace-vikingo .ace_operator{\
color: #F09D92\
}\
.ace-vikingo .ace_punctuation,\
.ace-vikingo .ace_punctuation.ace_tag {\
color: #fff\
}\
.ace-vikingo .ace_constant.ace_character,\
.ace-vikingo .ace_constant.ace_language,\
.ace-vikingo .ace_constant.ace_numeric,\
.ace-vikingo .ace_constant.ace_other {\
color: #FBE798\
}\
.ace-vikingo .ace_invalid {\
color: #F8F8F0;\
background-color: #F92672\
}\
.ace-vikingo .ace_invalid.ace_deprecated {\
color: #F8F8F0;\
background-color: #AE81FF\
}\
.ace-vikingo .ace_support.ace_constant,\
.ace-vikingo .ace_support.ace_function {\
color: #C28DD5\
}\
.ace-vikingo .ace_fold {\
background-color: #A6E22E;\
border-color: #F8F8F2\
}\
.ace-vikingo .ace_storage.ace_type,\
.ace-vikingo .ace_support.ace_class,\
.ace-vikingo .ace_support.ace_type {\
font-style: italic;\
color: #66D9EF\
}\
.ace-vikingo .ace_entity.ace_name.ace_function,\
.ace-vikingo .ace_entity.ace_other,\
.ace-vikingo .ace_entity.ace_other.ace_attribute-name,\
.ace-vikingo .ace_variable {\
color: #A6E22E\
}\
.ace-vikingo .ace_variable.ace_parameter {\
font-style: italic;\
color: #FD971F\
}\
.ace-vikingo .ace_string {\
color: #BDE4A7\
}\
.ace-vikingo .ace_comment {\
color: #5E6A75\
}\
.ace-vikingo .ace_lparen, .ace-vikingo .ace_rparen {\
	color: #a7b6c4;\
}\
.ace-vikingo .ace_request_method {\
color:#8fb9e1\
}\
.ace-vikingo .ace_request_path {\
color:#ecba79\
}\
.ace-vikingo .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y\
}";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});

ace.define("ace/theme/httpresp",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {

exports.isDark = false;
exports.cssClass = "ace-httpresp";
exports.cssText = ".ace-httpresp .ace_gutter {\
\
color: #8F908A\
}\
.ace-httpresp .ace_print-margin {\
width: 1px;\
background: #555651\
}\
.ace-httpresp {\
background-color: #e4e7e7;\
color: #202020\
}\
.ace-httpresp .ace_scrollbar {\
	scrollbar-color: rgba(150, 174, 183, 0.5) rgba(242, 242, 242, 0.67);\
	scrollbar-width: thin;\
    transition: 0.15s all ease-in;\
}\
.ace-httpresp .ace_scrollbar:hover {\
	scrollbar-width: initial;\
}\
.ace-httpresp .ace_scrollbar-v::-webkit-scrollbar {\
  width: 5px;\
  transition: 0.15s all ease-in;\
}\
.ace-httpresp .ace_scrollbar-v:hover::-webkit-scrollbar {\
  width: 10px;\
}\
.ace-httpresp .ace_scrollbar-h::-webkit-scrollbar {\
  height: 5px;\
  transition: 0.15s all ease-in;\
}\
.ace-httpresp .ace_scrollbar-h:hover::-webkit-scrollbar {\
  height: 10px;\
}\
.ace-httpresp .ace_scrollbar::-webkit-scrollbar-track {\
  background-color: rgba(242, 242, 242, 0.67);\
  border-radius: 10px;\
}\
.ace-httpresp .ace_scrollbar::-webkit-scrollbar-thumb {\
  border-radius: 10px;\
  background-color: rgba(150, 174, 183, 0.5);\
}\
.ace-httpresp .ace_cursor {\
color: #82B0BF\
}\
.ace-httpresp .ace_marker-layer .ace_selection {\
background: #F0F4F5\
}\
.ace-httpresp .ace_marker-layer .ace_step {\
background: rgb(102, 82, 0)\
}\
.ace-httpresp .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid #49483E\
}\
.ace-httpresp .ace_marker-layer .ace_active-line {\
background: #eaeaea\
}\
.ace-httpresp .ace_gutter-active-line {\
background-color: #ececec\
}\
.ace-httpresp .ace_marker-layer .ace_selected-word {\
border: 1px solid #49483E\
}\
.ace-httpresp .ace_invisible {\
color: #52524d\
}\
.ace-httpresp .ace_entity.ace_name.ace_tag,\
.ace-httpresp .ace_keyword,\
.ace-httpresp .ace_meta.ace_tag,\
.ace-httpresp .ace_storage {\
color: #045f7d\
}\
.ace-httpresp .ace_operator{\
color: #F09D92\
}\
.ace-httpresp .ace_punctuation,\
.ace-httpresp .ace_punctuation.ace_tag {\
color: #fff\
}\
.ace-httpresp .ace_constant.ace_character,\
.ace-httpresp .ace_constant.ace_language,\
.ace-httpresp .ace_constant.ace_numeric,\
.ace-httpresp .ace_constant.ace_other {\
color: #AC8048\
}\
.ace-httpresp .ace_invalid {\
color: #F8F8F0;\
background-color: #F92672\
}\
.ace-httpresp .ace_invalid.ace_deprecated {\
color: #F8F8F0;\
background-color: #AE81FF\
}\
.ace-httpresp .ace_support.ace_constant,\
.ace-httpresp .ace_support.ace_function {\
color: #C28DD5\
}\
.ace-httpresp .ace_fold {\
background-color: #A6E22E;\
border-color: #F8F8F2\
}\
.ace-httpresp .ace_storage.ace_type,\
.ace-httpresp .ace_support.ace_class,\
.ace-httpresp .ace_support.ace_type {\
font-style: italic;\
color: #66D9EF\
}\
.ace-httpresp .ace_entity.ace_name.ace_function,\
.ace-httpresp .ace_entity.ace_other,\
.ace-httpresp .ace_entity.ace_other.ace_attribute-name,\
.ace-httpresp .ace_variable {\
color: #A6E22E\
}\
.ace-httpresp .ace_variable.ace_parameter {\
font-style: italic;\
color: #FD971F\
}\
.ace-httpresp .ace_string {\
color: #366C17\
}\
.ace-httpresp .ace_comment {\
color: #5E6A75\
}\
.ace-httpresp .ace_lparen, .ace-httpresp .ace_rparen {\
	color: #a7b6c4;\
}\
.ace-httpresp .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y\
}";

var dom = acequire("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});


ace.define("ace/mode/yaml_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

var YamlHighlightRules = function() {
    this.$rules = {
        "start" : [
            {
                token : ["request_method","request_path",'http_version'],
                regex : "^(GET|HEAD|POST)(?:\s*)(.+)(?:\s*)(HTTP.+)$"
            },
            {
                token : "comment",
                regex : "#.*$"
            }, {
                token : "list.markup",
                regex : /^(?:-{3}|\.{3})\s*(?=#|$)/
            },  {
                token : "list.markup",
                regex : /^\s*[\-?](?:$|\s)/
            }, {
                token: "constant",
                regex: "!![\\w//]+"
            }, {
                token: "constant.language",
                regex: "[&\\*][a-zA-Z0-9-_]+"
            }, {
                token: ["meta.tag", "keyword"],
                regex: /^(\s*\w.*?)(:(?=\s|$))/
            },{
                token: ["meta.tag", "keyword"],
                regex: /(\w+?)(\s*:(?=\s|$))/
            }, {
                token : "keyword.operator",
                regex : "<<\\w*:\\w*"
            }, {
                token : "keyword.operator",
                regex : "-\\s*(?=[{])"
            }, {
                token : "string", // single line
                regex : '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'
            }, {
                token : "string", // multi line string start
                regex : /[|>][-+\d\s]*$/,
                onMatch: function(val, state, stack, line) {
                    var indent = /^\s*/.exec(line)[0];
                    if (stack.length < 1) {
                        stack.push(this.next);
                    } else {
                        stack[0] = "mlString";
                    }

                    if (stack.length < 2) {
                        stack.push(indent.length);
                    }
                    else {
                        stack[1] = indent.length;
                    }
                    return this.token;
                },
                next : "mlString"
            }, {
                token : "string", // single quoted string
                regex : "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
            }, {
                token : "constant.numeric", // float
                regex : /(\b|[+\-\.])[\d_]+(?:(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)(?=[^\d-\w]|$)/
            }, {
                token : "constant.numeric", // other number
                regex : /[+\-]?\.inf\b|NaN\b|0x[\dA-Fa-f_]+|0b[10_]+/
            }, {
                token : "constant.language.boolean",
                regex : "\\b(?:true|false|TRUE|FALSE|True|False|yes|no)\\b"
            }, {
                token : "paren.lparen",
                regex : "[[({]"
            }, {
                token : "paren.rparen",
                regex : "[\\])}]"
            }, {
                token : "text",
                regex : /[^\s,:\[\]\{\}]+/
            }
        ],
        "mlString" : [
            {
                token : "indent",
                regex : /^\s*$/
            }, {
                token : "indent",
                regex : /^\s*/,
                onMatch: function(val, state, stack) {
                    var curIndent = stack[1];

                    if (curIndent >= val.length) {
                        this.next = "start";
                        stack.splice(0);
                    }
                    else {
                        this.next = "mlString";
                    }
                    return this.token;
                },
                next : "mlString"
            }, {
                token : "string",
                regex : '.+'
            }
        ]};
    this.normalizeRules();

};

oop.inherits(YamlHighlightRules, TextHighlightRules);

exports.YamlHighlightRules = YamlHighlightRules;
});

ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"], function(acequire, exports, module) {
"use strict";

var Range = acequire("../range").Range;

var MatchingBraceOutdent = function() {};

(function() {

    this.checkOutdent = function(line, input) {
        if (! /^\s+$/.test(line))
            return false;

        return /^\s*\}/.test(input);
    };

    this.autoOutdent = function(doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);

        if (!match) return 0;

        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({row: row, column: column});

        if (!openBracePos || openBracePos.row == row) return 0;

        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column-1), indent);
    };

    this.$getIndent = function(line) {
        return line.match(/^\s*/)[0];
    };

}).call(MatchingBraceOutdent.prototype);

exports.MatchingBraceOutdent = MatchingBraceOutdent;
});

ace.define("ace/mode/folding/coffee",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode","ace/range"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../../lib/oop");
var BaseFoldMode = acequire("./fold_mode").FoldMode;
var Range = acequire("../../range").Range;

var FoldMode = exports.FoldMode = function() {};
oop.inherits(FoldMode, BaseFoldMode);

(function() {

    this.getFoldWidgetRange = function(session, foldStyle, row) {
        var range = this.indentationBlock(session, row);
        if (range)
            return range;

        var re = /\S/;
        var line = session.getLine(row);
        var startLevel = line.search(re);
        if (startLevel == -1 || line[startLevel] != "#")
            return;

        var startColumn = line.length;
        var maxRow = session.getLength();
        var startRow = row;
        var endRow = row;

        while (++row < maxRow) {
            line = session.getLine(row);
            var level = line.search(re);

            if (level == -1)
                continue;

            if (line[level] != "#")
                break;

            endRow = row;
        }

        if (endRow > startRow) {
            var endColumn = session.getLine(endRow).length;
            return new Range(startRow, startColumn, endRow, endColumn);
        }
    };
    this.getFoldWidget = function(session, foldStyle, row) {
        var line = session.getLine(row);
        var indent = line.search(/\S/);
        var next = session.getLine(row + 1);
        var prev = session.getLine(row - 1);
        var prevIndent = prev.search(/\S/);
        var nextIndent = next.search(/\S/);

        if (indent == -1) {
            session.foldWidgets[row - 1] = prevIndent!= -1 && prevIndent < nextIndent ? "start" : "";
            return "";
        }
        if (prevIndent == -1) {
            if (indent == nextIndent && line[indent] == "#" && next[indent] == "#") {
                session.foldWidgets[row - 1] = "";
                session.foldWidgets[row + 1] = "";
                return "start";
            }
        } else if (prevIndent == indent && line[indent] == "#" && prev[indent] == "#") {
            if (session.getLine(row - 2).search(/\S/) == -1) {
                session.foldWidgets[row - 1] = "start";
                session.foldWidgets[row + 1] = "";
                return "";
            }
        }

        if (prevIndent!= -1 && prevIndent < indent)
            session.foldWidgets[row - 1] = "start";
        else
            session.foldWidgets[row - 1] = "";

        if (indent < nextIndent)
            return "start";
        else
            return "";
    };

}).call(FoldMode.prototype);

});

ace.define("ace/mode/httpreq",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/yaml_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/folding/coffee"], function(acequire, exports, module) {
"use strict";

var oop = acequire("../lib/oop");
var TextMode = acequire("./text").Mode;
var YamlHighlightRules = acequire("./yaml_highlight_rules").YamlHighlightRules;
var MatchingBraceOutdent = acequire("./matching_brace_outdent").MatchingBraceOutdent;
var FoldMode = acequire("./folding/coffee").FoldMode;

var Mode = function() {
    this.HighlightRules = YamlHighlightRules;
    this.$outdent = new MatchingBraceOutdent();
    this.foldingRules = new FoldMode();
    this.$behaviour = this.$defaultBehaviour;
};
oop.inherits(Mode, TextMode);

(function() {

    this.lineCommentStart = ["#", "//"];

    this.getNextLineIndent = function(state, line, tab) {
        var indent = this.$getIndent(line);

        if (state == "start") {
            var match = line.match(/^.*[\{\(\[]\s*$/);
            if (match) {
                indent += tab;
            }
        }

        return indent;
    };

    this.checkOutdent = function(state, line, input) {
        return this.$outdent.checkOutdent(line, input);
    };

    this.autoOutdent = function(state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
    };


    this.$id = "ace/mode/yaml";
}).call(Mode.prototype);

exports.Mode = Mode;

});



// WEBPACK FOOTER //
// ./src/ace-helpers.js